import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { NoActionPayload } from '@/types/no-action'
import { ComponentType } from '@/configuration/component/component-types'

export const useNoActionDeleteMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: NoActionPayload) =>
            hcaClientFactory.generalApi.deleteNoAction(payload.componentSid, payload.noActionData),
        onSuccess: async (response, payload) => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['componentStatus', payload.componentSid, ComponentType.Transformer] }),
                queryClient.invalidateQueries({ queryKey: ['componentStatus', payload.componentSid, ComponentType.Generator] }),
                queryClient.invalidateQueries({ queryKey: ['transformers', payload.componentSid, 'generalComments'] }),
                queryClient.invalidateQueries({ queryKey: ['generators', payload.componentSid, 'generalComments'] }),
            ])
        },
    })
}
